import React, { useState } from "react";

const Alerts = () => {
  const [deskMessage, setDeskMessage] = useState("");

  const showAlert = () => {
    alert("This is a simple alert!");
  };

  const myMessage = () => {
    setTimeout(() => {
      alert("Alert after 5 seconds!");
    }, 5000);
  };

  const myDesk = () => {
    const result = window.confirm("Do you want to continue?");
    if (result) {
      setDeskMessage("You pressed OK!");
    } else {
      setDeskMessage("You pressed Cancel!");
    }
  };

  const myPromp = () => {
    const name = window.prompt("Please enter your name:");
    if (name) {
      alert("Hello " + name);
    }
  };

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Alerts
      </h1>

      <div className="d-flex justify-content-between">
        <label>Click Button to see alert</label>
        <button className="btn btn-primary" onClick={showAlert}>
          Alert
        </button>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <label>On button click, alert will appear after 5 seconds</label>
        <button className="btn btn-primary" onClick={myMessage}>
          Click Me
        </button>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <label>On button click, confirm box will appear</label>
        <button className="btn btn-primary" onClick={myDesk}>
          Click Me
        </button>
        <div>{deskMessage}</div>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <label>On button click, prompt box will appear</label>
        <button className="btn btn-primary" onClick={myPromp}>
          Click Me
        </button>
      </div>
    </div>
  );
};

export default Alerts;